

















import Vue from 'vue';

export default Vue.extend({
  props: {
    data: {
      type: Object,
      required: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAttachmentPreview() {
      return !!this.data?.attachment_type;
    },
    showIsLoading() {
      return this.isLoading && !this.showAttachmentPreview;
    },
  },
});
